import React, { useState } from "react";
import { shouldShowPermissionCard } from "./pushSupport";

const DENIED_KEY = "touchpoint_portal_perm_denied_at";

interface EnableNotificationsCardProps {
  permission: NotificationPermission;
  onEnable: () => Promise<NotificationPermission>;
}

/**
 * Post-value-moment permission ask (TD-003): render this after the
 * client completes an approval action, never on load.
 */
export const EnableNotificationsCard: React.FC<
  EnableNotificationsCardProps
> = ({ permission, onEnable }) => {
  const [hidden, setHidden] = useState(false);

  const deniedAt = Number(localStorage.getItem(DENIED_KEY)) || null;
  if (hidden || !shouldShowPermissionCard(permission, deniedAt, Date.now())) {
    return null;
  }

  const handleEnable = async () => {
    const result = await onEnable();
    if (result !== "granted") {
      localStorage.setItem(DENIED_KEY, String(Date.now()));
    }
    setHidden(true);
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mx-4 mt-4 flex items-center justify-between gap-3">
      <p className="text-sm text-gray-700">
        Vuoi un avviso quando ci sono nuovi contenuti da approvare?
      </p>
      <button
        type="button"
        onClick={handleEnable}
        className="shrink-0 px-3 py-1.5 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors"
      >
        Attiva notifiche
      </button>
    </div>
  );
};
